import { useTranslations } from 'next-intl'
import styles from './LogoutModal.module.css'
import Button, { ButtonKind, ButtonSize } from '@/components/UI/Buttons/Button/Button'
import { useLogout } from '@/apiUtilities/mutations/useLogout'
import { API_Error } from '@/interfaces/api/response/api_response_types'
import { useRouter } from '@/i18n/navigation'

interface LogoutModalProps extends React.HTMLAttributes<HTMLDivElement> {
  onClose: () => void
}

export default function LogoutModal ({ onClose }: LogoutModalProps) {
  const t = useTranslations('Modals.Logout')
  const router = useRouter()
  const serverLogout = useLogout()

  /**
   * Cancel log out and close the log out modal
   * 
   * @param e - Mouse click event triggered by cancel button
   */
  function handleCancel (e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault()
    onClose()
  }

  /**
   * Logs out the current user and closes the log out modal
   * 
   * @param e - Mouse click event triggered by accept button
   */
  function handleConfirm (e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault()

    serverLogout.mutate(undefined, {
      onSettled: handleLogout,
      onError: (response: API_Error) => console.error(response.description)
    })
  }

  /**
   * Runs after a log out
   */
  async function handleLogout () {
    onClose()
    router.push('/')
  }

  return (
    <div className={styles.logoutWrapper}>
      <p className={`title3 ${styles.content}`}>{t('content')}</p>

      <div className={styles.buttons}>
        <Button kind={ButtonKind.PRIMARY} size={ButtonSize.MEDIUM} onClick={handleCancel}>
          {t('buttons.cancel')}
        </Button>

        <Button kind={ButtonKind.SECONDARY} size={ButtonSize.MEDIUM} onClick={handleConfirm}>
          {t('buttons.accept')}
        </Button>
      </div>
    </div>
  )
}